import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import {  finalize, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { downloadBlob } from '../../utils/downloadBlob';
import { CustomErrorStateMatcher } from '../../helpers/customerrorstate';
import { NavigationEnd, Router  } from '@angular/router';
import { HttpPaginatedDataSource } from '../../utils/HttpPaginatedDataSource';
import { MatSort, Sort } from '@angular/material/sort';
import { SpinnerService } from '../../service/spinner.service';
import { ExportService } from '../../service/export.service';
import { PosService } from '../../service/pointofsale.service';
import { Pos } from '@/dto/pos/pos';
import { StatusPOS } from '@/enum/statusPOS';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pointofsale',
  templateUrl: './pointofsale.page.html',
  styleUrls: ['./pointofsale.page.scss']
})
export class PointofsalePage implements OnInit, OnDestroy {
  public leftMenu;
  public esMatcher = new CustomErrorStateMatcher();
  private unsubscribe: Subscription[] = [];
  FilterForm: FormGroup;
  exportForm: FormGroup;

  public sortCol = "creation_date";
  public sortDir = "desc";

  public listNetwork : any[] = [];
  public data: HttpPaginatedDataSource<any>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('selectOption') selectOption: any;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public pageIndex = 1;
  public pageSize: number;
  public total :number;

  public currentLanguage: string;
  public pageSizeOpts: number[];
  public StatusPOS: typeof StatusPOS = StatusPOS;
  constructor( private router: Router, private exportService : ExportService, private formBuilder: FormBuilder,
    private spinnerService: SpinnerService, private posService: PosService, private translateService: TranslateService) {
  }

  public columnsToDisplay = ['net_ref', 'storename', 'city', 'network', 'deposit_limit', 'last_update', 'status'];

  ngOnInit() {
    this.data = new HttpPaginatedDataSource([]);
    this.data.sort = this.sort;
    this.pageSizeOpts = [5, 10, 15, 20, 100];
    this.data.paginator = this.paginator;
    this.pageSize = 15;
    this.pageIndex = 0;

    this.unsubscribe.push(this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
      }
    }));

    this.FilterForm = this.formBuilder.group({
      net_ref: [''],
      storename: [''],
      city : [''],
      network_id : [''],
      status : [''],
      last_modified : [''],
      zipcode : [''],
      minDate : [''],
      maxDate : [''],
      minDeposit: [''],
      maxDeposit: ['']
    });

    this.exportForm = this.formBuilder.group({
      typeExport : 'csv'
    })

    this.unsubscribe.push(this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url === '/point-of-sale') {
        this.unsubscribe.push(
          this.posService.getListNetWork().pipe(finalize(() => {
            this.spinnerService.hide();
          })).subscribe(val => {
            if(val.length > 0) {
              this.listNetwork = val
            }
          })
        );
        this.onSubmit(this.pageSize,this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
      }
    }));

    this.sort.sortChange.subscribe((sort: Sort) => {
      this.paginator.pageIndex = 0;
      this.pageIndex = 0;
      this.data = new HttpPaginatedDataSource([]);
      this.sortCol = sort.active;
      this.sortDir = sort.direction;
      this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
    });
  }

  cancel(form: NgForm) {
    this.selectOption.nativeElement.value = '';
    this.selectOption.nativeElement.setAttribute('placeholder', this.translateService.instant('Transaction.Text.SelectOne'));
    form.resetForm();
    this.FilterForm.reset();
    this.FilterForm.markAsUntouched();
    this.exportForm.patchValue({typeExport : 'csv'});
  }

  get f() { return this.FilterForm.controls; }

  handleExport() {
    let typeForm = this.exportForm.controls.typeExport.value
    this.unsubscribe.push(this.exportService.getExportPOS(typeForm, this.CreateDataFilter(), this.sortCol, this.sortDir).pipe(finalize(() => {
      this.spinnerService.hide();
    })).subscribe( data => { downloadBlob(data, 'PointofsalePage.' + typeForm)}))
  }

  handleChangeNetwork (e) {
    let txt_placeholder = e.target.value || ''
    this.selectOption.nativeElement.value = ''
    this.FilterForm.patchValue({
      network_id : txt_placeholder
    })
    this.selectOption.nativeElement.setAttribute('placeholder', txt_placeholder)
  }

  onSubmit(pageSize: number, pageIndex: number, dataFilter : Pos, sortCol: string, sortDir: string) {
    this.spinnerService.show();

    this.unsubscribe.push(
      this.posService.get(pageIndex, pageSize, dataFilter, sortCol, sortDir).pipe(finalize(() => {
        this.spinnerService.hide();
      })).subscribe(val => {
        this.data.data = val.data;
        this.data.sort = this.sort;
        this.data.sortingDataAccessor = (item, property) => {
          if (property === 'status') {
            let text = this.translateService.instant(StatusPOS[item[property]]);
            return text.toLocaleLowerCase();
          } else if (typeof item[property] === 'string') {
            return item[property].toLocaleLowerCase();
          } else {
            return item[property];
          }
        };
        this.data._updatePaginator(val.total)
      }
    )
    );
  }

  private CreateDataFilter(): Pos {
    const pos = new Pos();
    pos.net_ref__icontains = this.f.net_ref.value
    pos.storename__icontains = this.f.storename.value
    pos.city__icontains = this.f.city.value
    pos.network_id = this.parseValueFromNetworkInput(this.f.network_id.value)
    pos['deposit_limit__gte'] = this.f.minDeposit.value
    pos['deposit_limit__lte'] = this.f.maxDeposit.value
    pos.status = this.f.status.value
    pos.zipcode__icontains = this.f.zipcode.value
    pos.last_modified = this.f.last_modified.value

    const startOfDay = new Date(this.f.minDate.value);
    startOfDay.setUTCHours(0, 0, 0, 0);
    const endOfDay = new Date(this.f.minDate.value);
    endOfDay.setUTCHours(23, 59, 59, 999);

    pos['last_modified__gte'] = this.f.minDate.value ? startOfDay.toISOString() : ""
    pos['last_modified__lte'] = this.f.maxDate.value ? endOfDay.toISOString() : ""
    pos["lang"] = this.translateService.currentLang;
    return pos;
  }

  goToDetails(path){
    if (path !== undefined)
      this.router.navigate(['/point-of-sale/'+path.id])
  }

  filterForm() {
    this.onSubmit(20, 0, this.CreateDataFilter(), this.sortCol, this.sortDir);
  }

  change(pageEvent: PageEvent)  {
    if (this.pageIndex !== pageEvent.pageIndex || this.pageSize !== pageEvent.pageSize) {
      this.pageIndex = pageEvent.pageIndex;
      this.pageSize = pageEvent.pageSize;
      this.data = new HttpPaginatedDataSource([]);
      this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
    }
  }

  parseValueFromNetworkInput (value : string) {
    for(let i = 0; i < this.listNetwork.length; i++) {
      if(this.listNetwork[i].name == value) return this.listNetwork[i].id
    }
    return ""
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }
}
